import { SafeDatabaseUser } from '../types/types';
import * as userService from './userService';

/**
 * Initiates the 2FA setup process for a user
 * @param username The username of the user
 * @param email The email address to send verification codes to
 */
export const initiateSetup = async (username: string, email: string): Promise<void> => {
  await userService.setupTwoFactor(username, email);
};

/**
 * Verifies a 2FA code during setup
 */
export const verifySetupCode = async (
  username: string,
  code: string,
): Promise<SafeDatabaseUser> => {
  const response = await userService.enableTwoFactor(username, code);
  return response.user;
};

/**
 * Verifies a 2FA code during login
 */
export const verifyLoginCode = async (username: string, code: string): Promise<SafeDatabaseUser> =>
  userService.verifyTwoFactor(username, code);

/**
 * Builds an updated user object with 2FA enabled
 * Note: This is only used as a fallback if the API doesn't return the updated user
 */
export const getUpdatedUserWithTwoFactorEnabled = (user: SafeDatabaseUser): SafeDatabaseUser => ({
  ...user,
  twoFactorEnabled: true,
});
